<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'product/index' }">
                                Produk
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Produk
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-auto">
                <router-link v-bind:to="{ name: 'product/add' }" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2">
                    Create New Produk +
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4 col-md-6" v-for="(product, index) in products">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Produk # {{ index + 1 }}
                                </span>
                            </div>
                            <div class="col-auto">
                                <router-link v-bind:to="{name: 'product/edit', params: {id: product.id}}" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button class="btn btn-link h4 p-0 my-0" v-on:click="modalShow = true; reference = product;">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="text-muted">
                            Gambar Produk:
                        </div>
                        <img v-bind:src="product.imageUrl" v-bind:alt="product.name" class="img-fluid mb-2 rounded w-100" />
                        <div class="text-muted">
                            Judul Produk:
                        </div>
                        <p class="card-text font-weight-bold">
                            {{ product.name }}
                        </p>
                        <div class="text-muted">
                            Harga Produk:
                        </div>
                        <p class="card-text">
                            {{ product.price | currency }}
                        </p>
                        <div class="text-muted">
                            Deskripsi:
                        </div>
                        <p class="card-text">
                            {{ product.description }}
                        </p>
                        <div class="text-muted">
                            Cabang:
                        </div>
                        <p class="mb-2">
                            <ul class="mb-0 pl-3">
                                <li class="text-loading mb-1" v-for="branch in product.branches">
                                    {{ branch.name }}
                                </li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-model="modalShow" v-if="reference" v-on:hide="reference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">
                            Apa yakin mau menghapus produk <strong>{{ reference.name }}</strong>?
                            <br />
                            Karena jika sudah terhapus data tidak dapat dikembalikan
                        </h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    export default {
        name: "ProductIndex",
        data() {
            return {
                modalShow: false,
                reference: null,
                products: [{}, {}, {}, {}, {}]
            };
        },
        methods: {
            confirmation(model) {
                this.modalShow = true;
                this.reference = model;
            },
            remove() {
                if (this.reference) {
                    this.axios.post(process.env.API_URL + '/product/delete/' + this.reference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.fetchData();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modalShow = false;
                        this.reference = null;
                    });
                }
            },
            fetchData() {
                this.axios.get(process.env.API_URL + '/product').then(response => {
                    this.products = response.data.data;
                });
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {
            document.title = 'List Produk - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/product/Index.vue